import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'counter'];

  static values = {
    maxCharactersLength: Number,
    hintBasicMessage: String,
    hintExceededMessage: String,
  };

  initialize() {
    this.countCharacters();
  }

  countCharacters() {
    const charactersLength = this.inputTarget.value.length;
    let message = this.hintBasicMessageValue;

    if (!this.hasMaxCharactersLengthValue) {
      return this.setMessage(message, charactersLength);
    }

    const charactersRemain = this.maxCharactersLengthValue - charactersLength;

    if (this.hasHintExceededMessageValue && charactersRemain < 0) {
      message += ` ${this.hintExceededMessageValue}`;
      this.counterTarget.classList.add('red-text');
    } else {
      this.counterTarget.classList.remove('red-text');
    }

    this.setMessage(message, charactersLength);
  }

  setMessage(message, charactersLength) {
    this.counterTarget.innerText = message.replaceAll(
      '_COUNTER',
      charactersLength,
    );
  }
}
